import transactionService from "../services/transactions";

const namespace = "transactions";

const initialState = {
  loading: {
    createExpense: false,
  },
  expenseData: null,
};

export const createExpense = (payload) => ({
  type: `${namespace}/createExpense`,
  payload,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *createExpense({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "createExpense" });
      try {
        const response = yield call(transactionService.createExpense, payload);
        yield put({
          type: "setExpenseData",
          payload: response.data,
        });
      } catch (error) {
        console.error("Error creating expense:", error);
      }
      yield put({ type: "stopLoading", loadingType: "createExpense" });
    },
  },
  reducers: {
    setExpenseData(state, { payload }) {
      return { ...state, expenseData: payload };
    },

    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
